import React from 'react'

export const RestoreIcon = ({ id, onclick }) => {
    return (
        <svg id={id} onClick={onclick} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id={id} d="M5.66668 0.999957V2.99994C5.66668 2.99994 11 2.5 11 10.5C11 10.5 10.3334 5.66663 5.66668 5.66663V7.66664L1 4.33329L5.66668 0.999957Z" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}
